import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { MainIcon } from 'page/MainIcon/MainIcon'
import { store } from 'store/store'
import css from './MiniRound.module.scss'

export const MiniRound = observer(() => {
  const { inferences } = store.inferences
  const complete = inferences.every((it) => it.complete)
  const loader = !store.ready || !complete
  const error = store.error

  const onMax = useLatestCallback(() => {
    store.state = 'max'
  })

  return (
    <Space
      className={css.root}
      width={64}
      height={64}
      center
      onClick={onMax}
    >
      {error ? (
        <Icon size={24} name="error" error />
      ) : loader ? (
        <Loader />
      ) : (
        <MainIcon size={32} />
      )}
    </Space>
  )
})
